import { signal } from '@angular/core';
import { TwcLegendParams } from '../../../twc-legend/twc-legend.params';
import { TwcLegendComponent } from '../../../twc-legend/twc-legend.component';
import { AIRMETsSvgComponent } from './airmets-svg/airmets-legend-svg';

export const AIRMETS_LEGEND: TwcLegendParams = {
  title: 'AIRMETS',
  legendTitleBarInfo: signal('0'),
  data: { svgComponent: AIRMETsSvgComponent },
  legendComponent: TwcLegendComponent
};
